<template>
  <main class="m-t-70 page-services">
    <div class="page-headline m-b-30 m-t-70 align-center">
      <h1 class="headline page-headline__title m-b-20">{{ pageInfo.title }}</h1>
      <h4 class="tagline page-headline__tagline" v-html="pageInfo.content"></h4>
    </div>
  
    <div class="section-services align-center">

      <div class="align-center">
        <div class="question m-b-30">
          <h1 class="question__text">
            <strong class="question__number">01</strong>
            {{ $t("services.softwareServicesTitle") }}
          </h1>
        </div>
      </div>

      <div class="container-fluid">
          <div class="row">
              <div class="col-xs-12 col-md-4 col-lg-4 solution" v-for="solution in softwareSolutions" :key="solution.id">
                <div class="article has-shadow">
                  <object ref="mySVG" :id="solution.id" type="image/svg+xml" width="75px" height="150px" :data="solution.image_url"></object>
                    <div class="solution__desc">
                        <h3 class="headline section__header__headline">{{ solution.title }}</h3>
                        <p class="tagline section__header__tagline">{{ solution.content }}</p>
                    </div>
                  </div>
              </div>
          </div>
      </div>

        <div class="align-center service-process">
          <h3 class="aside--title">{{ $t("services.softwareServicesProcessTitle") }}</h3>
          <img src="~@/assets/images/banner-icons-en.png" width="700px" class="responsive-image" alt="" v-if="this.$i18n.locale == 'en'"/>
          <img src="~@/assets/images/banner-icons-ar.png" width="700px" class="responsive-image" alt="" v-if="this.$i18n.locale == 'ar'"/> 
        </div>

    </div>

    <div class="section-services align-center">

      <div class="align-center">
        <div class="question m-b-30">
          <h1 class="question__text">
            <strong class="question__number">02</strong>
            {{ $t("services.digitalServicesTitle") }}
          </h1>
        </div>
      </div>

      <div class="container-fluid">
          <div class="row">
              <div class="col-xs-12 col-md-4 col-lg-4 solution" v-for="solution in marketingSolutions" :key="solution.id">
                <div class="article has-shadow">
                  <object ref="mySVG" :id="solution.id" type="image/svg+xml" width="75px" height="150px"  :data="solution.image_url"></object>
                    <div class="solution__desc">
                        <h3 class="headline section__header__headline">{{ solution.title }}</h3>
                        <p class="tagline section__header__tagline">{{ solution.content }}</p>
                    </div>
                  </div>
              </div>
          </div>
      </div>

      <div class="align-center service-process">
        <h3 class="aside--title">{{ $t("services.digitalServicesProcessTitle") }}</h3>
        <img src="~@/assets/images/marketing-services-steps-en.png" width="900px" class="responsive-image" alt="" v-if="this.$i18n.locale == 'en'"/>
        <img src="~@/assets/images/marketing-services-steps-ar.png" width="900px" class="responsive-image" alt="" v-if="this.$i18n.locale == 'ar'"/> 
      </div>
    </div>

  </main>
</template>

<script>
export default {
	name: "Services",
	data() {
		return {
			pageTitle: "Loading...",
			pageInfo: {},
			softwareSolutions: [],
			marketingSolutions: []
		};
	},
	metaInfo() {
		return {
			title: this.pageTitle,
			meta: [
				{ itemprop: "name", content: this.pageInfo.meta_og_description },
				{ itemprop: "description", content: this.pageInfo.meta_og_description },
				{ name: "og:title", content: this.pageInfo.meta_og_title },
				{ name: "og:description", content: this.pageInfo.meta_og_description },
				{ name: "og:url", content: this.pageInfo.meta_url },
				{ name: "og:site_name", content: this.pageInfo.meta_twitter_site },
				{ name: "og:type", content: this.pageInfo.meta_og_type },
				{ name: "og:image", content: this.pageInfo.meta_og_image_url },

				{ name: "twitter:card", content: this.pageInfo.meta_twitter_card },
				{ name: "twitter:site", content: this.pageInfo.meta_twitter_site },
				{ name: "twitter:title", content: this.pageInfo.meta_twitter_title },
				{
					name: "twitter:description",
					content: this.pageInfo.meta_twitter_description
				},
				{
					name: "twitter:creator",
					content: this.pageInfo.meta_twitter_creator
				},
				{ name: "twitter:image", content: this.pageInfo.meta_twitter_image_url }
			]
		};
	},
	created() {
		this.getPageInfo();
		this.getAll();
	},
	methods: {
		getAll() {
			this.$http
				.get(
					this.$parent.$parent.apiURL +
						"/textblocks/text-blocks-widgets?filter[name]=services-software-solutions"
				)
				.then(function(response) {
					this.softwareSolutions = response.body.widget_blocks;
				});

			this.$http
				.get(
					this.$parent.$parent.apiURL +
						"/textblocks/text-blocks-widgets?filter[name]=service-digital-marketing"
				)
				.then(function(response) {
					this.marketingSolutions = response.body.widget_blocks;
				});
		},

		getPageInfo() {
			this.$http
				.get(this.$parent.$parent.apiURL + "/Pages?id=8")
				.then(function(response) {
					this.pageInfo = response.body;
					this.pageTitle = this.pageInfo.title;
				});
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/Services.vue